// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 알림 빠른 설정 팝업 */

.aqp-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.4);
  z-index: 1500;
  display: flex;
  align-items: center;
  justify-content: center;
}

.aqp-popup {
  background: #fff;
  border-radius: 7px;
  width: 320px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.22);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.aqp-hd {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 11px 14px;
  font-size: 14px;
  font-weight: 700;
  background: #f0f2f8;
  border-bottom: 1px solid #dde2ef;
}

.aqp-close {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  color: #555;
  line-height: 1;
}

.aqp-sub {
  padding: 7px 14px;
  font-size: 12px;
  color: #333;
  background: #fafbff;
  border-bottom: 1px solid #eee;
}
.aqp-acct { color: #666; margin-left: 4px; }
.aqp-turn { color: #1976d2; font-weight: 600; margin-left: 4px; }

.aqp-loading {
  padding: 20px;
  text-align: center;
  font-size: 12px;
  color: #888;
}

.aqp-bd {
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* 알림 활성 체크박스 행 */
.aqp-enabled-row {
  margin-bottom: 4px;
}
.aqp-enabled-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  cursor: pointer;
  font-weight: 600;
}
.aqp-enabled-label input { width: 14px; height: 14px; cursor: pointer; }

/* 상승/하락 알림 행 */
.aqp-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.aqp-row-label {
  width: 52px;
  font-size: 12px;
  font-weight: 600;
  flex-shrink: 0;
}
.aqp-up   { color: #d32f2f; }
.aqp-down { color: #1565c0; }

.aqp-select {
  flex: 1 1;
  padding: 5px 7px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 12px;
  font-family: inherit;
  background: #fff;
}
.aqp-select:focus { outline: none; border-color: #4a90e2; }

/* 안내 문구 */
.aqp-hint {
  font-size: 11px;
  color: #888;
  background: #fffbe6;
  border: 1px solid #ffe082;
  border-radius: 4px;
  padding: 6px 10px;
}

/* 하단 */
.aqp-ft {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 9px 14px;
  border-top: 1px solid #eee;
  gap: 8px;
}

.aqp-ft-right {
  display: flex;
  gap: 6px;
}

.aqp-type-btn {
  font-size: 11px;
  color: #555;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/AlertQuickPopup.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB;EACE,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,uCAAuC;EACvC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,6BAA6B;AAC/B;AACA,YAAY,WAAW,EAAE,gBAAgB,EAAE;AAC3C,YAAY,cAAc,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;;AAEhE;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;AACA,2BAA2B,WAAW,EAAE,YAAY,EAAE,eAAe,EAAE;;AAEvE,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA,YAAY,cAAc,EAAE;AAC5B,YAAY,cAAc,EAAE;;AAE5B;EACE,SAAO;EACP,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;AACA,oBAAoB,aAAa,EAAE,qBAAqB,EAAE;;AAE1D,UAAU;AACV;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,OAAO;AACP;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,0BAA0B;EAC1B,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;AACb","sourcesContent":["/* 알림 빠른 설정 팝업 */\n\n.aqp-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.4);\n  z-index: 1500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.aqp-popup {\n  background: #fff;\n  border-radius: 7px;\n  width: 320px;\n  box-shadow: 0 4px 24px rgba(0,0,0,0.22);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.aqp-hd {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 11px 14px;\n  font-size: 14px;\n  font-weight: 700;\n  background: #f0f2f8;\n  border-bottom: 1px solid #dde2ef;\n}\n\n.aqp-close {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 16px;\n  color: #555;\n  line-height: 1;\n}\n\n.aqp-sub {\n  padding: 7px 14px;\n  font-size: 12px;\n  color: #333;\n  background: #fafbff;\n  border-bottom: 1px solid #eee;\n}\n.aqp-acct { color: #666; margin-left: 4px; }\n.aqp-turn { color: #1976d2; font-weight: 600; margin-left: 4px; }\n\n.aqp-loading {\n  padding: 20px;\n  text-align: center;\n  font-size: 12px;\n  color: #888;\n}\n\n.aqp-bd {\n  padding: 12px 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n/* 알림 활성 체크박스 행 */\n.aqp-enabled-row {\n  margin-bottom: 4px;\n}\n.aqp-enabled-label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  cursor: pointer;\n  font-weight: 600;\n}\n.aqp-enabled-label input { width: 14px; height: 14px; cursor: pointer; }\n\n/* 상승/하락 알림 행 */\n.aqp-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.aqp-row-label {\n  width: 52px;\n  font-size: 12px;\n  font-weight: 600;\n  flex-shrink: 0;\n}\n.aqp-up   { color: #d32f2f; }\n.aqp-down { color: #1565c0; }\n\n.aqp-select {\n  flex: 1;\n  padding: 5px 7px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 12px;\n  font-family: inherit;\n  background: #fff;\n}\n.aqp-select:focus { outline: none; border-color: #4a90e2; }\n\n/* 안내 문구 */\n.aqp-hint {\n  font-size: 11px;\n  color: #888;\n  background: #fffbe6;\n  border: 1px solid #ffe082;\n  border-radius: 4px;\n  padding: 6px 10px;\n}\n\n/* 하단 */\n.aqp-ft {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 9px 14px;\n  border-top: 1px solid #eee;\n  gap: 8px;\n}\n\n.aqp-ft-right {\n  display: flex;\n  gap: 6px;\n}\n\n.aqp-type-btn {\n  font-size: 11px;\n  color: #555;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
